import { HUBSPOT_DEFINED } from 'automation-ui-associations/constants/AssociationCategory';
import { isSupportedAssociation } from 'automation-ui-associations/utils/isSupportedAssociation';
// Subscription related:
//   296 -> CONTACT_TO_SUBSCRIPTION
//   298 -> COMPANY_TO_SUBSCRIPTION
//   300 -> DEAL_TO_SUBSCRIPTION
//   304 -> QUOTE_TO_SUBSCRIPTION
//
// Invoice related:
//   176 -> DEAL_TO_INVOICE
//   180 -> COMPANY_TO_INVOICE
//
export const cleanGatedAssociationDefinitions = (associationDefinitions, {
  hasSubscriptionObjectAccess,
  hasPaymentObjectAccess,
  hasInvoiceAccess,
  hasPartnerClientAccess,
  hasPartnerAccountAccess,
  hasPartnerServiceAccess
} = {}, ignoreAccess = false) => {
  const cleanedAssociationDefinitions = Object.assign({}, associationDefinitions);
  let ASSOCIATED_DEFINITIONS_TO_EXCLUDE = [];
  if (!hasSubscriptionObjectAccess) {
    ASSOCIATED_DEFINITIONS_TO_EXCLUDE = ASSOCIATED_DEFINITIONS_TO_EXCLUDE.concat([296, 298, 300, 304]);
  }
  if (!hasPaymentObjectAccess) {
    ASSOCIATED_DEFINITIONS_TO_EXCLUDE = ASSOCIATED_DEFINITIONS_TO_EXCLUDE.concat([387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398]);
  }
  if (!hasInvoiceAccess) {
    ASSOCIATED_DEFINITIONS_TO_EXCLUDE = ASSOCIATED_DEFINITIONS_TO_EXCLUDE.concat([175, 177, 178, 179, 407, 408, 409, 410]);
  }
  if (!hasPartnerClientAccess) {
    ASSOCIATED_DEFINITIONS_TO_EXCLUDE = ASSOCIATED_DEFINITIONS_TO_EXCLUDE.concat([616, 617]);
  }
  if (!hasPartnerAccountAccess) {
    ASSOCIATED_DEFINITIONS_TO_EXCLUDE = ASSOCIATED_DEFINITIONS_TO_EXCLUDE.concat([584, 585]);
  }
  if (!hasPartnerServiceAccess) {
    ASSOCIATED_DEFINITIONS_TO_EXCLUDE = ASSOCIATED_DEFINITIONS_TO_EXCLUDE.concat([806, 807]);
  }
  if (!ignoreAccess && associationDefinitions && ASSOCIATED_DEFINITIONS_TO_EXCLUDE.length) {
    cleanedAssociationDefinitions.allDefinitions = cleanedAssociationDefinitions.allDefinitions.filter(({
      category,
      id
    }) => !(category === HUBSPOT_DEFINED && ASSOCIATED_DEFINITIONS_TO_EXCLUDE.includes(id))).filter(isSupportedAssociation);
  }
  return cleanedAssociationDefinitions;
};